import { useExclusiveOffer } from '@/hooks/common/use-exclusive-offer';
import { plansModalOpenAtom } from '@/jotai/atom';
import { OfferFloatingButton } from '@workspace/ui/components/offer-floating-button';
import { useSetAtom } from 'jotai';
import { useLocation } from 'react-router-dom';

const ExclusiveOfferHost = () => {
  const { offer } = useExclusiveOffer();
  const { pathname } = useLocation();
  const setPlansModalOpen = useSetAtom(plansModalOpenAtom);

  if (!offer || pathname.startsWith('/project/preview/')) return null;

  return (
    <OfferFloatingButton
      offer={offer}
      onClaim={() => setPlansModalOpen(true)}
      dataPhSelector="builder-offer-float"
    />
  );
};

export default ExclusiveOfferHost;
